<template>
	<v-snackbar
		:color="alert.type"
		v-model="alert.value"
		left
		shaped
		bottom
	>
		<div class="d-flex justify-space-between align-center">
			<span class="ev-text-small white--text">{{ alert.message }}</span>
			<v-btn icon small @click="$store.commit('alert/close')">
				<v-icon small>mdi-close</v-icon>
			</v-btn>
		</div>
	</v-snackbar>
</template>
<script>
export default {
	name: 'EvAlert',
	computed: {
		alert() {
			return this.$store.state.alert;
		},
	},
}
</script>
